import { useHubble } from '@seek/hubble';
import { useConfig } from '@seek/libs-shared';
import { useMelwaysLink } from '@seek/melways-react';
import { useTranslations } from '@vocab/react';
import { Autosuggest, Box, filterSuggestions } from 'braid-design-system';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { CompanyProfilesPage, ROOT_PATH } from '../../../../paths';
import type { SalaryRangeByRole } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab';

interface AutosuggestValue {
  text: string;
  description?: string;
  value?: string;
}

export const SalariesSearchBar = ({
  salaryRangeByRoles,
}: {
  salaryRangeByRoles: SalaryRangeByRole[];
}) => {
  const { language } = useConfig();
  const navigate = useNavigate();
  const params = useParams();
  const localize = useMelwaysLink();

  const [role, setRole] = useState<AutosuggestValue>({
    text: '',
  });

  const hubble = useHubble();

  const roleSuggestions: AutosuggestValue[] =
    salaryRangeByRoles?.map((range) => ({
      text: range.roleTitle,
      value: range.roleId,
    })) || [];

  const { t } = useTranslations(translations);

  return (
    <Box paddingBottom={'large'} data={{ testid: 'salaries-search-bar' }}>
      <Autosuggest
        id="roleFilter"
        data={{ testid: 'roleFilterAutoSuggest' }}
        placeholder={
          roleSuggestions.length > 0
            ? t('e.g. keyword', {
                keyword: roleSuggestions[0].text,
              })
            : ''
        }
        aria-label={'Search for job roles'}
        value={role}
        suggestions={filterSuggestions(roleSuggestions)}
        onChange={(e) => {
          setRole({ text: e.text });
          if (e.value && params.companySlug) {
            hubble.trackEvent('component_pressed', {
              component: {
                name: 'search salaries',
                valueSelected: [e.text],
                type: 'autosuggest',
              },
              currentPageSection: 'salaries',
            });
            const viewSalaryByRoleLink = localize({
              path: `/${ROOT_PATH}/${params.companySlug}/${CompanyProfilesPage.Salaries}/${e.value}`,
              language,
            });
            void navigate(viewSalaryByRoleLink);
          }
        }}
        onClear={() => {
          setRole({ text: '' });
        }}
      />
    </Box>
  );
};
